import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsAsync(clientId) {
        return (await Vue.http.get(`/api/vegas/settings/${clientId}`)).data;
    },
    async saveSettingsAsync(clientId, settings) {
        await Vue.http.post(`/api/vegas/settings/${clientId}`, settings);
        noty.success("Settings saved successfully");
    }
};


// WEBPACK FOOTER //
// ./src/services/vegas.service.js